import { EventEmitter } from 'events';
class EventSystem {
    constructor() {
        Object.defineProperty(this, "eventEmitter", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "externalEventEmitter", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "emit", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (event, payload, options = { visibility: 'internal' }) => {
                this.eventEmitter.emit(event, payload);
                if (options.visibility === 'external') {
                    this.externalEventEmitter.emit(event, payload);
                }
            }
        });
        Object.defineProperty(this, "off", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (event, listener) => {
                this.eventEmitter.off(event, listener);
            }
        });
        Object.defineProperty(this, "on", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (event, listener) => {
                this.eventEmitter.on(event, listener);
            }
        });
        this.eventEmitter = new EventEmitter();
        this.externalEventEmitter = new EventEmitter();
    }
}
class ExternalEventSystem {
    constructor(eventEmitter) {
        Object.defineProperty(this, "eventEmitter", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: eventEmitter
        });
        Object.defineProperty(this, "addEventListener", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (event, listener) => {
                this.eventEmitter.on(event, listener);
            }
        });
        Object.defineProperty(this, "dispatchEvent", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (event, payload) => {
                this.eventEmitter.emit(event, payload);
            }
        });
        Object.defineProperty(this, "removeEventListener", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (event, listener) => {
                this.eventEmitter.off(event, listener);
            }
        });
    }
}
export const eventSystem = new EventSystem();
export const externalEventSystem = new ExternalEventSystem(eventSystem['externalEventEmitter']);
